import React from 'react';
import { Layout } from 'antd';
import { useAliveController } from 'react-activation';
import KeepAliveTabs from './KeepAliceTab';

const NavContent = () => {
  const { Header } = Layout;
  const { getCachingNodes } = useAliveController();
  const cachingNodes = getCachingNodes();

  if (!cachingNodes.length) return null;

  return (
    <Header
      aria-label="已打开的页面"
      style={{
        padding: 0,
        background: '#fff',
        height: 'auto',
        lineHeight: '45px',
        flexShrink: 0,
        overflowX: 'auto',
        overflowY: 'hidden',
      }}
    >
      <KeepAliveTabs />
    </Header>
  );
};

export default NavContent;
